<template>
  <div>
    <div
      class="d-flex align-items-center justify-content-center w-100"
      style="height: 250px"
      v-if="load"
    >
      <loader color="#e0a638" size="100" />
    </div>
    <transition name="vertical">
      <p
        v-if="solicitacoes.length == 0 && !load"
        class="my-5 text-center w-100"
        style="font-size: 16px; color: #ffff"
      >
        Ainda não existem solicitações pendentes
      </p>
    </transition>
    <div
      class="col-md-12 element_div px-0"
      style="overflow-x: hidden; overflow-y: hidden"
    >
      <transition-group
        name="list-complete"
        tag="div"
        class="d-flex over-scroll"
      >
        <ValidationObserver
          class="col-md-5 itens list-complete-item"
          v-for="(item, index) in solicitacoes"
          :key="index + 1"
          ref="form"
        >
          <div class="box py-4 px-4 mb-2">
            <topo
              :item="item"
              :nome.sync="item.name"
              :link.sync="item.link"
              :type.sync="item.type"
              :value.sync="item.value"
              :secondValue.sync="item.secondValue"
              :cost.sync="item.cost"
              :categoryId.sync="item.categoryId"
              :tenantInformation="item.tenantInformation"
            />

            <passo :instructions="item.instructions" :index="index" />
            <unidades
              :tenants="item.tenants"
              :index="item.id"
              :unidades="unidades"
              @tenants="tenantsFunction"
              ref="unidade"
              :id="item.id"
              :key="item.id"
            />
            <!-- :tenant.sync='tenantTeste' -->
            <!-- :tenant.sync="tenant" -->
            <!-- {{tenantTeste[index]}} -->

            <linkVideo />
            <popUp :HasPopup.sync="item.HasPopup" :teste.sync="item.id" />
            <aprova
              :IsEdit="false"
              :item="item"
              :tenant="tenantTeste[index]"
              :unidades="unidades"
              :tenants="item.tenants"
              :index="index"
              @getService="getService"
              @removeTenantFilter="removeTenantFilter"
            />
          </div>
        </ValidationObserver>
      </transition-group>
    </div>
  </div>
</template>

<script>
import topo from "./item/topo";
import passo from "./item/passoApasso";
import unidades from "./item/unidades";
import aprova from "./item/aprova";
import linkVideo from "./item/linkVideo";
import popUp from "./item/popUp";
import HTTP from "@/api_system";
import loader from "@/components/utils/_Load";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    topo,
    passo,
    unidades,
    aprova,
    loader,
    linkVideo,
    popUp
  },
  data() {
    return {
      solicitacoes: "",
      unidades: [],
      load: true,
      tenantTeste: []
    };
  },
  mounted() {
    this.getService();
    this.getUnidades();
  },
  methods: {
    ...mapActions(["getSolicitacao"]),
    tenantsFunction(unidade, id) {
      let { tenantTeste } = this;
      let newValueUnidade = [];

      let filterValue = tenantTeste.filter(item => item.id !== id);
      newValueUnidade.push(...filterValue, { unidade, id });

      newValueUnidade.sort((x, y) => x.id - y.id); // função para ordenar do menor id ate o maior

      this.tenantTeste = newValueUnidade;
      return;
    },
    removeTenantFilter(items) {
      let { tenantTeste } = this;

      let filterValue = tenantTeste.filter(item => item.id !== items.id);
      filterValue.sort((x, y) => x.id - y.id);
      this.tenantTeste = filterValue;
    },
    getService() {
      this.disabled = true;
      this.load = true;
      HTTP.get(`services/app/Service/GetServicesinAnalysis`, {
        headers: {
          Authorization: `Bearer ${this.$store.getters.getterToken}`
        }
      })
        .then(response => {
          this.load = false;
          this.disabled = false;
          this.solicitacoes = response.data.result;
          this.$nextTick(() => {
            this.scroll();
          });
        })
        .catch(error => {
          this.load = false;
          this.disabled = false;
          this.$notify({
            group: "erros",
            type: "error",
            text: `<i class="icon ion-close-circled"></i>Ops algo deu errado`
          });
        });
    },
    scroll() {
      var elementW = $(".element_div").width();
      var valTotal = $(".itens").length;

      var w = $(".itens").width() * valTotal;
      var valMin = elementW - w - 30 * $(".itens").length;
      Draggable.create(".over-scroll", {
        type: "x",
        throwProps: true,
        edgeResistance: 0.9,
        maxDuration: 0,
        bounds: { maxX: 0, minX: valTotal > 2 ? valMin : 0 },
        snapX: [0, valMin]
      });
    },
    getUnidades() {
      this.load = true;
      HTTP.post("services/app/Tenant/ListOfTenants", "", {
        headers: {
          Authorization: `Bearer ${this.$store.getters.getterToken}`
        }
      })
        .then(response => {
          this.unidades = response.data.result.activeTenants;
        })
        .catch(error => {
          this.load = false;
        });
    }
  },
  computed: mapGetters(["get_message"]),
  watch: {
    get_message: function() {
      if (this.get_message == 2) {
        this.getService();
        this.getUnidades();
        this.getSolicitacao();
      }
    }
  }
};
</script>

<style scoped>
.box {
  background-color: #ffffff;
  width: 100%;
  min-height: 400px;
  border: none;
  border-radius: 20px;
  box-shadow: 0px 3px 6px 0 rgba(68, 68, 68, 0.3);
}
.over-scroll {
  cursor: pointer !important;
}
</style>
